import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import MKBox from "components/MKBox";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/DefaultFooter";
import ContainerCard from "components/ContainerCard";
import SettingsOverview from "./sections/SettingsOverview";
import Container from "@mui/material/Container";
import Breadcrumbs from "examples/Breadcrumbs";

function ChatbotDefaults() {
  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />
      <ContainerCard>
        <Container>
          <Breadcrumbs
            routes={[{ label: "Admin", route: "/admin" }, { label: "Chatbot Instellingen" }]}
          />
          <SettingsOverview />
        </Container>
      </ContainerCard>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ChatbotDefaults;
